import { render, staticRenderFns } from "./InventorySubscriptions.vue?vue&type=template&id=7401f6a2&scoped=true"
import script from "./InventorySubscriptions.vue?vue&type=script&lang=js"
export * from "./InventorySubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7401f6a2",
  null
  
)

export default component.exports